import React from 'react';
import { genNonce } from '../../../utils/utils';
import GoogleIcon from '../../../assets/common/images/icon/google.png'
import { trans } from '../../../localization/index';

class GoogleLogin extends React.Component {
  render() {
    const { clientId, redirectUri, scope, state } = this.props;
    const params = {
      client_id: clientId,
      redirect_uri: redirectUri,
      scope,
      state,
      response_type: 'permission id_token',
      fetch_basic_profile: 'true',
      nonce: genNonce(),
    };
    return (
      <form
        id="google-login-form"
        action={CONFIG.GOOGLE_OAUTH2_ENDPOINT}
        method="GET"
      >
        {Object.keys(params).map(p => (
          <input key={p} type="hidden" name={p} value={params[p]} />
        ))}
        <div
          className="item plus"
          onClick={() => {
            $('#google-login-form').submit();
          }}
        >
          <img src={GoogleIcon} alt="google icon" />
          <span className="col">{trans('login_with_google')}</span>
        </div>
      </form>
    );
  }
}

export default GoogleLogin;



// WEBPACK FOOTER //
// ./foody/src/pages/Login/Components/GoogleLogin.jsx